import { ApiResponseType } from '@/types/sharedTypes';
import { authApiService } from '@/api/authApiService';
import { InternalOrganizationUserType } from '@/bundle/_MasterAdmin/types/types';

export type EditInternalOrganizationUserPayloadType = {
  mobile_phone?: string;
  first_name: string;
  middle_name?: string;
  last_name: string;
};

export const editInternalOrganizationUserApi = async (
  userId: string,
  data: EditInternalOrganizationUserPayloadType
): Promise<ApiResponseType<InternalOrganizationUserType>> => {
  const uri = `/organization/internal/users/${userId}/`;

  return authApiService.PATCH(uri, data);
};
